import React, { useContext, useEffect, useState } from 'react';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { Icon } from "@iconify/react/dist/iconify.js";
import '../../css/accountSetting.css'
import '../../css/app/settings.css'
import SidebarContext from '../../contexts/MyContext';
import { errorToast } from '../../utils/notificationUtils';




const AccountSetting = () => {
    const [isCurrentUser, setIsCurrentUser] = useState()

    const location = useLocation();
    const { user, storeUser } = useContext(SidebarContext);
    const isActive = (path) => location.pathname === path;

    useEffect(() => {
        const userData = localStorage.getItem("currentUser");

        const convertedUserData = JSON.parse(userData)
        setIsCurrentUser(convertedUserData)
    }, []);


    return (
        <div className='vr-set'>
            <div className='container vr-set-container'>
                {/* <div style={{
                    height: '100%'

                }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', background: '#ffffff', padding: '10px 0px', margin: '25px 0px 25px 0px', border: '1px solid #FFFFFF', borderRadius: '10px' }}>
                        <div>
                            <img src='/img/accountsetting/left.png' style={{ padding: '16px', height: '72px', width: '72px' }} />
                        </div>
                        <div>
                            <p style={{
                                fontFamily: "Metropolis",
                                fontWeight: "600",
                                fontSize: "20px",
                                color: "#2C3E5D",
                                margin: '0'
                            }}>Manage subscription in the App Store</p>
                            <span
                                style={{
                                    margin: "0",
                                    fontFamily: "Metropolis",
                                    fontWeight: "600",
                                    fontSize: "16px",
                                    color: "#64748B",
                                }}
                            >You 12 Month subscription will automatically begin on March 4, 2024</span>
                        </div>
                    </div>
                </div> */}
                <div className='account-settings-layout vr-set-shell'>
                    <Sidebar className='vr-set-nav'>
                        <Menu>
                            <MenuItem className={isActive('/accountsetting/account') ? 'vr-set-navitem is-active' : 'vr-set-navitem'} component={<Link to="/accountsetting/account" />}>
                                <Icon icon="lucide:user-round" className="icon vr-set-navicon" role="img" aria-label="Account Settings Icon" />
                                <span className='vr-set-navlabel'>Account</span>
                            </MenuItem>
                            {!user?.isGoogle && !user?.isApple ? (
                                <MenuItem className={isActive('/accountsetting/settingpassword') ? 'vr-set-navitem is-active' : 'vr-set-navitem'} component={<Link to="/accountsetting/settingpassword" />}>
                                    <Icon icon="lucide:key-round" className="icon vr-set-navicon" role="img" aria-label="Account Settings Icon" />
                                    <span className='vr-set-navlabel'>
                                        Password
                                    </span>
                                </MenuItem>
                            ) : (<></>)}

                            <MenuItem className={isActive('/accountsetting/recordingquality') ? 'vr-set-navitem is-active' : 'vr-set-navitem'} component={<Link to="/accountsetting/recordingquality" />}>
                                <Icon icon="lucide:mic" className="icon vr-set-navicon" role="img" aria-label="Account Settings Icon" />
                                <span className='vr-set-navlabel'>
                                    Recording quality
                                </span>
                            </MenuItem>
                            <MenuItem className={isActive('/accountsetting/audioformat') ? 'vr-set-navitem is-active' : 'vr-set-navitem'} component={<Link to="/accountsetting/audioformat" />}>
                                <Icon icon="lucide:file-audio" className="icon vr-set-navicon" role="img" aria-label="Account Settings Icon" />
                                <span className='vr-set-navlabel'>
                                    Default audio format
                                </span>
                            </MenuItem>
                            {/* <MenuItem component={<Link to="/accountsetting/syncwithcloud" />}>
                                <img
                                    src={isActive('/accountsetting/syncwithcloud')
                                        ? "/img/accountsetting/syncwithcloud-active.png"
                                        : "/img/accountsetting/cloud.png"}
                                    alt="Account Settings Icon"
                                    className="icon"
                                />
                                <span style={{ color: isActive('/accountsetting/syncwithcloud') ? "#334155" : "#94A3B8",fontFamily: "Metropolis", fontWeight: "600", fontSize: "12px" }}>
                                    Sync with cloud
                                </span>
                            </MenuItem> */}
                            {/* <MenuItem component={<Link to="/accountsetting/support" />}>
                                <img
                                    src={isActive('/accountsetting/support')
                                        ? "/img/accountsetting/support-active.png"
                                        : "/img/accountsetting/support.png"}
                                    alt="Account Settings Icon"
                                    className="icon"
                                />
                                <span style={{ color: isActive('/accountsetting/support') ? "#334155" : "#94A3B8", fontFamily: "Metropolis", fontWeight: "600", fontSize: "12px" }}>
                                    Support
                                </span>
                            </MenuItem> */}

                            <MenuItem className={isActive('/accountsetting/manage-plan') ? 'vr-set-navitem is-active' : 'vr-set-navitem'} component={<Link to={!isCurrentUser?.hasSubscribe ? "/pricing" : "/accountsetting/manage-plan"} />}>
                                <Icon icon="lucide:crown" className="icon vr-set-navicon" role="img" aria-label="Account Settings Icon" />
                                <span className='vr-set-navlabel'>
                                    Manage Plan
                                </span>
                            </MenuItem>


                        </Menu>

                    </Sidebar>
                    <div className="content-area vr-set-content">
                        <Outlet />
                    </div>
                </div >
            </div>
        </div>
    )
}

export default AccountSetting
